export enum MonochromeColorToken {
  white = '#FFFFFF',
  black = '#000000',
}

export default MonochromeColorToken

export type TMonochrome = 'white' | 'black'
